import React from 'react';
import './Card.css';

export const Card = ({ children, className = '', glow = false, ...props }) => {
  return (
    <div 
      className={`mp-card ${glow ? 'mp-card--glow' : ''} ${className}`} 
      {...props}
    >
      <span className="mp-card__border" aria-hidden="true" />
      <div className="mp-card__inner">{children}</div>
    </div>
  );
};

export const CardHeader = ({ title, subtitle, action, className = '' }) => {
  return (
    <div className={`mp-card-header ${className}`}>
      <div className="mp-card-header__content">
        {title && <h3 className="mp-card-header__title">{title}</h3>}
        {subtitle && <span className="mp-card-header__subtitle">{subtitle}</span>}
      </div>
      {action && <div className="mp-card-header__action">{action}</div>}
    </div>
  );
};

export const CardSection = ({ children, className = '' }) => {
  return (
    <div className={`mp-card-section ${className}`}>
      {children}
    </div>
  );
};

export const CardDivider = () => {
  return <div className="mp-card-divider" />;
};

export const CardFooter = ({ children, className = '' }) => {
  return (
    <div className={`mp-card-footer ${className}`}>
      {children}
    </div>
  );
};

export const CardMedia = ({ src, alt, className = '' }) => {
  return (
    <img src={src} alt={alt} className={`mp-card-media ${className}`} />
  );
};
